<afoone-breadcrumb></afoone-breadcrumb>

<div
  class="header-container"
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 0.75rem;
  "
>
  <h3>{{ queryName }}</h3>
  <div class="header-actions" style="display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap">
    <p-selectButton
      *ngIf="showPivotToolbar"
      [options]="viewModeOptions"
      [(ngModel)]="viewMode"
      (ngModelChange)="onViewModeChange()"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>
    <p-button
      *ngIf="viewMode === 'pivot' && showPivotToolbar && !isPivotBlocked && !pivotLoading"
      [label]="'QUERY.PIVOT_EXPORT_BUTTON' | translate"
      icon="pi pi-download"
      (onClick)="exportPivotCsv()"
    ></p-button>
    <p-button
      icon="pi pi-code"
      (onClick)="openDebugDialog()"
      [disabled]="!debugQuery"
      [rounded]="true"
      styleClass="p-button-text"
      [style]="{
        'background-color': 'white',
        color: 'darkgray',
        border: '1px solid #ddd',
        width: '1.8rem',
        height: '1.8rem',
        'border-radius': '50%',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center'
      }"
      [title]="'QUERY.DEBUG_QUERY_TITLE' | translate"
    ></p-button>
  </div>
</div>

<p-dialog
  [(visible)]="showDebugDialog"
  [modal]="true"
  [style]="{ width: '80vw', maxWidth: '1200px' }"
  [header]="'QUERY.DEBUG_QUERY_HEADER' | translate"
  [draggable]="false"
  [resizable]="true"
>
  <div style="margin-bottom: 1rem">
    <div style="font-weight: bold; display: block; margin-bottom: 0.5rem">
      {{ "QUERY.DEBUG_QUERY_LABEL" | translate }}
    </div>
    <textarea
      [value]="debugQuery"
      readonly
      style="
        width: 100%;
        height: 400px;
        font-family: 'Courier New', monospace;
        font-size: 12px;
        padding: 1rem;
        background-color: #f5f5f5;
        border: 1px solid #ddd;
        border-radius: 4px;
        resize: vertical;
      "
    ></textarea>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      [label]="'QUERY.DEBUG_QUERY_CLOSE' | translate"
      icon="pi pi-times"
      (onClick)="closeDebugDialog()"
      styleClass="p-button-text"
    ></p-button>
    <p-button
      [label]="'QUERY.DEBUG_QUERY_COPY' | translate"
      icon="pi pi-copy"
      (onClick)="copyToClipboard()"
    ></p-button>
  </ng-template>
</p-dialog>

<div *ngIf="viewMode === 'pivot' && pivotLoading" class="pivot-status">
  <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem"></i>
  {{ "QUERY.PIVOT_LOADING" | translate }}
</div>

<div *ngIf="viewMode === 'pivot' && isPivotBlocked" class="pivot-blocked-message" role="alert">
  {{ pivotBlockedMessage }}
</div>

<p-table
  *ngIf="viewMode === 'list'"
  [value]="determinaciones"
  [paginator]="!!parsedData"
  [scrollable]="true"
  [scrollHeight]="'calc(100vh - 220px)'"
  styleClass="p-datatable-sm p-datatable-striped"
  [rows]="limit"
  [first]="offset"
  [totalRecords]="totalCount"
  [lazy]="true"
  (onLazyLoad)="loadDataLazy($event)"
  [rowsPerPageOptions]="[5, 10, 20]"
  dataKey="id"
>
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let field of fields" [id]="'header-' + field.attribute">
        {{ field.description | translate }}
      </th>
      <th
        *ngFor="let item of camposSensibilidad; let i = index"
        [id]="'header-' + item"
        [ngClass]="{ 'even-column': i % 3 === 0, 'odd-column': i % 3 !== 0 }"
      >
        {{ item.startsWith('descAntibiotico') ? ('QUERY.ANTIBIOTICO' | translate) : camelCaseToTitleCase(item) }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td *ngFor="let field of fields">
        {{ formatListFieldValue(field, record) }}
      </td>
      <td
        *ngFor="let item of camposSensibilidad; let i = index"
        [ngClass]="{ 'even-column': i % 3 === 0, 'odd-column': i % 3 !== 0 }"
      >
        {{ record[item] }}
      </td>
    </tr>
  </ng-template>
</p-table>

<p-table
  *ngIf="viewMode === 'pivot' && !pivotLoading && !isPivotBlocked"
  [value]="pivotRows"
  [paginator]="!!parsedData"
  [scrollable]="true"
  [scrollHeight]="'calc(100vh - 220px)'"
  styleClass="p-datatable-sm p-datatable-striped pivot-table"
  [rows]="limit"
  [first]="offset"
  [totalRecords]="totalCount"
  [lazy]="true"
  (onLazyLoad)="loadDataLazy($event)"
  [rowsPerPageOptions]="[5, 10, 20]"
  [dataKey]="'codpeticion'"
>
  <ng-template pTemplate="header">
    <tr>
      <th pFrozenColumn class="pivot-frozen-header">{{ "QUERY.PIVOT_FROZEN_PETICION" | translate }}</th>
      <th pFrozenColumn class="pivot-frozen-header">{{ "QUERY.PIVOT_FROZEN_FECHA_PETICION" | translate }}</th>
      <th *ngFor="let col of pivotDynamicColumns" class="pivot-param-header">{{ col.header }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td pFrozenColumn class="pivot-frozen-cell">{{ row["numPeticion"] }}</td>
      <td pFrozenColumn class="pivot-frozen-cell">{{ formatDeterminacionDateTime(row["fechaPeticionDt"]) }}</td>
      <td *ngFor="let col of pivotDynamicColumns" class="pivot-param-cell">{{ row[col.field] }}</td>
    </tr>
  </ng-template>
</p-table>
